import React, { Fragment } from 'react';

import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { Tabs, TabsItem } from '../ui/Tabs'
import Builder from "../Builder"
import BuilderCanvas from "../BuilderCanvas"
import { withTranslation } from 'react-i18next'
import { setViewTab, zoomButtonClicked } from '../../actions/ui';
import store from '../../store/redux_store'
import ZoomInIcon from '../icons/ZoomIn';
import ZoomOutIcon from '../icons/ZoomOut';
import HideIcon from '../icons/HideIcon';

class BuilderPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      widthWindow: window.innerWidth,
      isHeaderHidden: false,
    }

    this.containerRef = React.createRef()
  }

  componentDidMount = () => {
    const node = this.containerRef.current;
    this.setState({
      offsetTop: node.offsetTop,
      offsetHeigh: node.offsetHeigh,
    })
  }

  changeViewedTab = (event, value) => {
    store.dispatch(setViewTab(value))
  }

  checkDisabled = (tabIndex) => {
    if (tabIndex === 3 && !this.props.sizeScenario) {
      return true
    }
    return false;
  }

  handleHideHeader = () => {
    const { isHeaderHidden } = this.state;

    const header = document.querySelector('header');
    const bLayout = document.querySelector('.b-layout');

    if(!isHeaderHidden) { 
      if(header) {
        header.style.display = 'none';
      }
      if(bLayout) {
        bLayout.style.top = '0';
        bLayout.style.height = '100%';
      }
    } else {
      if(header) {
        header.style.display = 'block';
      }
      if(bLayout) {
        bLayout.style.top = '68px';
        bLayout.style.height = 'calc(100% - 68px)';
      }
    }

    this.setState({
      isHeaderHidden: !isHeaderHidden,
    })
  }


  renderSmallCanvas = () => {
    const { isHeaderHidden } = this.state;
    const { viewedTab, imagesLoading } = this.props
    const tabs = this.getTabContet()

    return (
      <Fragment>
        <nav className="b-navbar">
          <div className="step-nav">
            <Tabs value={viewedTab} onChange={this.changeViewedTab}>
              {tabs.map((t, i) =>
                <TabsItem
                  key={i}
                  value={i}
                  className='b-navbar__item'
                >
                  {t}
                </TabsItem>)
              }
            </Tabs>
          </div>
        </nav>
        <div
          ref={this.containerRef}
          className='b-content-wrapper'
        >
          <div className='b-canvas-wrapper'>
            <div className='b-content-wrapper__close'>
              <button
                className={"close b-content-wrapper__hide-header" + (isHeaderHidden ? ' rotate-180' : '')}
                onClick={this.handleHideHeader}
              >
                <HideIcon />
              </button>
            </div>
            {
              <div className='b-content-wrapper__zoom'>
                <button
                  className="b-zoom-wrapper b-content-wrapper__zoom-canvas"
                  onClick={this.handleZoomClick}
                >
                  <ZoomInIcon />
                </button>
              </div>
            }
            {imagesLoading && 
            <div className="b-canvas-loader-overlay">
              <div className="b-canvas-loader">
                <span/>
              </div>
            </div>
            }
            <div className="b-content-wrapper__render">
              <BuilderCanvas type="builder"/>
            </div>
          </div>
          <Builder />
        </div>
      </Fragment>
    )
  }

  renderLargeCanvas = () => {
    const { imagesLoading } = this.props
    return (
      <div
        className='b-shirt-preview'
      >
        <button
          className="b-zoom-wrapper b-content-wrapper__zoom-canvas b-content-wrapper__zoom-canvas-out"
          onClick={this.handleZoomClick}
        >
          <ZoomOutIcon />
        </button>
        {imagesLoading && 
        <div className="b-canvas-loader-overlay">
          <div className="b-canvas-loader">
            <span/>
          </div>
        </div>
        }
        <BuilderCanvas
          className="b-shirt-preview__canvas"
          type="preview"
        />
      </div>

    )
  }

  handleZoomClick = () => {
    let toggled = !this.props.zoomMode
    store.dispatch(zoomButtonClicked(toggled))
  }


  getTabContet = () => [
    'ТКАНЬ',
    'ДЕТАЛИ',
    'РАЗМЕР',
    'МОЙ ЗАКАЗ'
  ]

  render() {
    const { zoomMode } = this.props;
    let canvas = this.renderSmallCanvas()
    if (zoomMode) {
      canvas = this.renderLargeCanvas()
    }

    return (
      <Fragment>
        {canvas}
      </Fragment>
    );
  }
}

BuilderPage.propTypes = {
  viewedTab: PropTypes.number.isRequired,
  zoomMode: PropTypes.bool.isRequired,
  imagesLoading: PropTypes.bool.isRequired,
  sizeScenario: PropTypes.string
};

function mapStateToProps(state, ownProps) {

  return {
    ...ownProps,
    viewedTab: state.ui.selectedTab,
    zoomMode: state.ui.zoomMode,
    imagesLoading: state.ui.imagesLoading
  };
}

export default connect(
  mapStateToProps,
  null
)(withTranslation()(BuilderPage));